// Data for Trademark Examining Lawyer website

export const testimonials = [
  {
    id: 1,
    name: "Nathan Brooks",
    role: "CEO, Brooks Wellness Group",
    content: "We had concerns about protecting our brand before launching nationwide. The team handled every step of the trademark application process and kept us informed throughout. Their professionalism gave us complete confidence.",
    rating: 5
  },
  {
    id: 2,
    name: "Madison Harper",
    role: "Owner, Harper Outdoor Supply",
    content: "The trademark search uncovered potential conflicts we would have never noticed ourselves. Their guidance saved us time, money, and the risk of future legal disputes.",
    rating: 5
  },
  {
    id: 3,
    name: "Ethan Caldwell",
    role: "Founder, Caldwell Home Collections",
    content: "I appreciated how responsive and knowledgeable the specialists were. They answered every question promptly and made what seemed like a complicated process surprisingly straightforward.",
    rating: 5
  },
  {
    id: 4,
    name: "Victoria Hayes",
    role: "President, Hayes Logistics Partners",
    content: "After receiving an office action from the USPTO, I was worried our application would be denied. Their team prepared a strong response, and our trademark was successfully registered.",
    rating: 5
  },
  {
    id: 5,
    name: "Brandon Mitchell",
    role: "Managing Director, Mitchell Consumer Brands",
    content: "Their attention to detail and commitment to protecting our intellectual property exceeded expectations. We now have multiple trademarks registered and feel secure expanding our business.",
    rating: 5
  },
  {
    id: 6,
    name: "Lauren Simmons",
    role: "Co-Founder, Simmons Digital Ventures",
    content: "The entire experience was seamless from start to finish. Their transparent communication and expert support made trademark registration one of the easiest parts of launching our company.",
    rating: 5
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Provide Your Information",
    description: "Share your business and brand details through our secure submission form. Our team evaluates eligibility, reviews potential concerns, and identifies conflicts before proceeding.",
    icon: "Search"
  },
  {
    id: 2,
    title: "Application Preparation & Submission",
    description: "Our legal team carefully prepares all required paperwork, selects appropriate trademark classifications, and files your application directly with the USPTO.",
    icon: "FileText"
  },
  {
    id: 3,
    title: "Registration Tracking & Oversight",
    description: "After submission, we monitor every development, address examiner requests when necessary, and provide ongoing supervision to help protect your registered trademark.",
    icon: "Shield"
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Attorney Package",
    price: "499",
    recommended: false,
    features: [
      "Case Review & Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "100% Satisfaction & Approval Guaranteed",
      "Refusal Risk Meter",
      "Trademark Monitoring (12 months)",
      "Complete Documentation",
      "Non Final Action Response Filing",
      "Dedicated IP Attorney",
      "Comprehensive Trademark Search Report (Federal & State)",
      "24 Hrs. Expedited Service",
      "Cease & Desist Letter",
      "IP Attorney 24/7 support"
    ],
    // note: "Govt. filing fee not included"
  },
  {
    id: 2,
    name: "Abandoned Application Package",
    price: "599",
    recommended: true,
    features: [
      "Case Review & Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "100% Satisfaction & Approval Guaranteed",
      "Refusal Risk Meter",
      "Trademark Monitoring (12 months)",
      "Complete Documentation",
      "Non Final Action Response Filing",
      "Response to Abandonment of Application",
      "Statement of Use Filing",
      "Dedicated IP Attorney",
      "Comprehensive Trademark Search Report (Federal & State)",
      "24 Hrs. Expedited Service",
      "Cease & Desist Letter",
      "IP Attorney 24/7 support"
    ],
    // note: "Govt. filing fee not included"
  }
];

export const services = [
  {
    id: 1,
    title: "Trademark Registration",
    slug: "trademark-registration",
    shortDescription: "Establish exclusive rights to your brand name, logo, or slogan.",
    icon: "Award"
  },
  {
    id: 2,
    title: "Copyright Registration",
    slug: "copyright-registration",
    shortDescription: "Safeguard your original creative works and authored content.",
    icon: "Copyright"
  },
  {
    id: 3,
    title: "Trademark Comprehensive Search",
    slug: "trademark-search",
    shortDescription: "Uncover potential conflicts before you file your application.",
    icon: "Search"
  },
  {
    id: 4,
    title: "Company Formation",
    slug: "company-formation",
    shortDescription: "Set up the right legal entity structure for your venture.",
    icon: "Building2"
  },
  {
    id: 5,
    title: "Amazon Brand Registry",
    slug: "amazon-brand-registry",
    shortDescription: "Enroll and protect your brand across the Amazon marketplace.",
    icon: "Package"
  }
];

export const countryCodes = [
  { code: "+1", country: "USA/Canada" },
  { code: "+44", country: "UK" },
  { code: "+91", country: "India" },
  { code: "+61", country: "Australia" },
  { code: "+49", country: "Germany" },
  { code: "+33", country: "France" },
  { code: "+86", country: "China" },
  { code: "+81", country: "Japan" },
  { code: "+55", country: "Brazil" },
  { code: "+52", country: "Mexico" }
];

export const attorneys = [
  {
    id: 1,
    name: "Dominique James",
    admitted: "May 8, 2025",
    school: "Yale Law School",
    firm: "Latham & Watkins",
    location: "Los Angeles",
    specialties: ["Corporate Law", "Mergers and Acquisitions", "Business Advisory Matters"],
    barId: "360839",
    phone: "(773) 805-9531"
  },
  {
    id: 2,
    name: "Devin S. Crowley",
    admitted: "December 2, 2014",
    specialties: ["Civil Litigation", "Business Law", "Legal Counseling", "Dispute Resolution", "Client Advocacy"],
    barId: "300577",
    phone: "(773) 805-5965"
  },
  {
    id: 3,
    name: "Joseph Lee",
    specialties: ["Corporate Law", "Commercial Transactions", "Business Advisory", "Contract Negotiations", "Strategic Legal Guidance"],
    barId: "249435",
    phone: "(551) 417-3746"
  },
  {
    id: 4,
    name: "Scott R James",
    specialties: ["Business Law", "Commercial Litigation", "Dispute Resolution", "Risk Management", "Legal Counsel"],
    barId: "294378"
  }
];
